interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

export default function ProgressBar({ currentStep, totalSteps }: ProgressBarProps) {
  return (
    <div className="w-full max-w-2xl mx-auto mb-12">
      <div className="flex items-center justify-between">
        {Array.from({ length: totalSteps }, (_, i) => {
          const stepNumber = i + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;

          return (
            <div key={stepNumber} className="flex items-center flex-1">
              {/* Step Circle */}
              <div className="flex flex-col items-center">
                <div
                  className={`w-12 h-12 rounded-full border-2 flex items-center justify-center font-bold transition-all duration-200 ${
                    isCompleted
                      ? 'bg-black dark:bg-gray-100 border-black dark:border-gray-300 text-white dark:text-black'
                      : isCurrent
                      ? 'bg-white dark:bg-gray-900 border-black dark:border-gray-300 text-black dark:text-gray-100 shadow-brutal'
                      : 'bg-white dark:bg-gray-900 border-gray-300 dark:border-gray-700 text-gray-400'
                  }`}
                >
                  {isCompleted ? (
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  ) : (
                    stepNumber
                  )}
                </div>
                <span className="text-xs mt-2 font-semibold text-gray-600 dark:text-gray-400">
                  Step {stepNumber}
                </span>
              </div>

              {/* Connecting Line */}
              {stepNumber < totalSteps && (
                <div
                  className={`flex-1 h-0.5 mx-2 transition-all duration-200 ${
                    isCompleted
                      ? 'bg-black dark:bg-gray-300'
                      : 'bg-gray-300 dark:bg-gray-700'
                  }`}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
